import { Icon } from '@/components';
import { useUiStore } from '@/stores/ui.store';
import { A } from '@solidjs/router';
import type { JSX } from 'solid-js';

export const MobileTopBar = (): JSX.Element => {
  const { openMobileDrawer } = useUiStore();
  return (
    <header
      class="flex h-12 items-center justify-between border-b border-neutral-200 bg-white px-3 shadow-sm dark:border-neutral-800 dark:bg-neutral-950"
      style={{ 'padding-top': 'env(safe-area-inset-top)' }}
    >
      <button
        type="button"
        class="rounded-lg p-1 text-neutral-700 transition-colors hover:bg-neutral-100 dark:text-neutral-200 dark:hover:bg-neutral-800"
        onClick={openMobileDrawer}
        aria-label="Open navigation"
      >
        <Icon name="menu-burger" />
      </button>
      <A href="/devices" class="font-semibold text-brand-600 dark:text-brand-400">
        UChat - Hera
      </A>
      <span class="w-7" />
    </header>
  );
};
